import { type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  projectDataExport: "Analytics.AnalyticsProjectDataExport",
  billingDetailExport: "Analytics.AnalyticsBillingDetailExport",
  projectDeliverableReport: "Analytics.AnalyticsProjectDeliverableReport",
};

export { names as analyticsRouteNames };

const quickBooksRoutes: RouterOptions["routes"] = [
  {
    path: "/analytics",
    component: () => import("@/views/analytics/AnalyticsBase.vue"),
    children: [
      {
        path: "exportProjectData",
        name: names.projectDataExport,
        meta: { title: "Project Data Export", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsProjectDataExport.vue"),
      },
      {
        path: "exportBillingDetails",
        name: names.billingDetailExport,
        meta: { title: "Billing Detail Export", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsBillingDetailExport.vue"),
      },
      {
        path: "projectDeliverableReport",
        name: names.projectDeliverableReport,
        meta: { title: "Project Deliverable Report", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsProjectDeliverablesReport.vue"),
      },
    ],
  },
];
export default quickBooksRoutes;
